import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { InviteService } from '@se-po/shared-data-access-services'
import { environment } from '@se-po/shared-environments'
import { UserServiceResources as us } from 'se-resource-types'

@Component({
  selector: 'se-po-minor-account-accept',
  templateUrl: './minor-account-accept.component.html',
  styleUrls: ['./minor-account-accept.component.scss'],
})
export class MinorAccountAcceptComponent implements OnInit {
  public actionUrl: string
  public existingAccount = false
  public emailAddress: string
  public form: FormGroup
  public fromName = ''
  public inviteId: string
  public invite: us.Invitation
  public ready = false

  constructor(
    private fb: FormBuilder,
    private inviteService: InviteService,
    private route: ActivatedRoute,
    private router: Router,
    private window: Window,
  ) {}

  public ngOnInit(): void {
    this.actionUrl = environment.staging || environment.production ? '/v2/auth' : `${environment.user}v2/auth`
    this.inviteId = this.route.snapshot.params.id
    this.inviteService.find(this.inviteId, { status: 'sent' }).subscribe({
      next: invite => {
        this.invite = invite
        this.existingAccount = !!invite.invited_user?.id
        this.emailAddress = invite.email_address?.address
        this.fromName = invite.persona?.first_name || ''
        this.createForm()
        this.ready = true
      },
      error: () => this.router.navigate(['/minor-account', 'not-found'])
    })
  }

  public onSubmit(): void {
    this.window.location.href = `${this.actionUrl}?token=${this.invite.token}`
  }

  private createForm(): void {
    this.form = this.fb.group({
      token: [this.invite.token]
    })
  }
}
